export const MAX_LENGTH_PER_REQUEST = 24;
